import React from 'react';
import DataTable, { StatusColumn } from '../DataTable';

export interface OrderData {
  id: string;
  client: string;
  code: string;
  quoteCode: string;
  date: string;
  value: string;
  status: string;
  paymentMethod: string;
  paymentTerm: string;
  [key: string]: unknown;
}

interface OrdersTableProps {
  data: OrderData[];
  className?: string;
  onViewOrder?: (orderId: string) => void;
}

const OrdersTable: React.FC<OrdersTableProps> = ({ data, className, onViewOrder }) => {
  const columns: Array<StatusColumn & { render?: (row: OrderData) => React.ReactNode }> = [
    {
      id: 'client',
      label: 'Cliente',
      minWidth: 170,
    },
    {
      id: 'quoteCode',
      label: 'Cotação de origem',
      minWidth: 150,
    },
    {
      id: 'date',
      label: 'Data do pedido',
      minWidth: 120,
    },
    // {
    //   id: 'paymentMethod',
    //   label: 'Método de pagamento',
    //   minWidth: 150,
    // },
    // {
    //   id: 'paymentTerm',
    //   label: 'Prazo de pagamento',
    //   minWidth: 150,
    // },
    {
      id: 'value',
      label: 'Valor total',
      minWidth: 120,
    },
    {
      id: 'status',
      label: 'Status do pedido',
      minWidth: 120,
      renderStatus: true,
      statusVariants: {
        Processando: {
          backgroundColor: '#e3f2fd',
          textColor: '#2196f3',
        },
        Enviado: {
          backgroundColor: '#FAFFF6',
          textColor: '#356E01',
        },
        'Em transporte': {
          backgroundColor: '#ede7f6',
          textColor: '#673ab7',
        },
        Entregue: {
          backgroundColor: '#e8f5e9',
          textColor: '#388e3c',
        },
        Cancelado: {
          backgroundColor: '#ffebee',
          textColor: '#d32f2f',
        },
      },
    },
  ];

  // Instead of using onRowClick prop which doesn't exist on DataTable,
  // we'll pass a custom function to handle row clicks via the onRowSelect callback
  const enhancedData = data.map((row: OrderData) => ({
    ...row,
    onClick: () => onViewOrder && onViewOrder(row.id),
  }));

  return (
    <DataTable
      columns={columns}
      data={enhancedData}
      statusField="status"
      containerClassName={className}
    />
  );
};

export default OrdersTable;
